import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { app } from '../../firebase';
import { Box } from '@mui/material';

const SignIn: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.email) {
      navigate('/reports', { replace: true });
    } else {
      const auth = firebase.auth(app);
      auth.tenantId = process.env.REACT_APP_TENANT_ID!;

      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
      ui.start('.firebaseui-auth-container', {
        signInFlow: 'popup',
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
          },
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          },
        ],
        signInSuccessUrl: '/#/reports',
        adminRestrictedOperation: {
          status: true,
        }
      });
    }
  }, [user.email, navigate]);

  return (
    <>
      <Box className='firebaseui-auth-container' style={{ marginTop: '200px' }}></Box>
    </>
  );
};

export default SignIn;
